import { GetStartedButton } from "./get-started-button";

export function CTA() {
  return (
    <section className="py-20 px-4 md:px-6 lg:px-8 bg-white text-center">
      <h2 className="text-3xl font-bold mb-6">
        Transform Your Teaching with Artificial Intelligence
      </h2>
      <p className="text-xl mb-2 max-w-3xl mx-auto">
        Be among the first to revolutionize your classroom with Worksheep AI.
      </p>
      <p className="text-xl mb-8 max-w-3xl mx-auto">
        Sign up now for early access.
      </p>
      <GetStartedButton size="lg" label="I'm ready lets go" />
    </section>
  );
}
